import { type Routes } from '@angular/router';

import { superAdminGuard } from './guard/super-admin.guard';
import { AdminAuditLogPageComponent } from './stubs/admin-audit-log-page.component';
import { AdminBillingPageComponent } from './stubs/admin-billing-page.component';
import { AdminBrandingPageComponent } from './stubs/admin-branding-page.component';
import { AdminMembersPageComponent } from './members/admin-members-page.component';
import { AdminOverviewPageComponent } from './overview/admin-overview-page.component';
import { AdminUpgradesPageComponent } from './upgrades/admin-upgrades-page.component';

/**
 * Routing surface for the Customer-Super-Admin section of the portal SPA.
 * Both `canMatch` and `canActivate` apply `superAdminGuard` — the former
 * prevents matching for non-super-admins; the latter catches the rare
 * race where the role check resolves later.
 *
 * Mounted under the parent shell route via `loadChildren`:
 *
 * ```ts
 * { path: 'admin', loadChildren: () => import('@echospaces-web-monorepo/es-portal-admin')
 *     .then((m) => m.adminRoutes) }
 * ```
 *
 * Sub-pages are eagerly imported here — the whole admin section is
 * already a lazy chunk at the app level, so further splitting inside
 * the lib only saves a few KB while making the build config noisier.
 */
export const adminRoutes: Routes = [
  {
    path: '',
    canMatch: [superAdminGuard],
    canActivate: [superAdminGuard],
    children: [
      { path: '', component: AdminOverviewPageComponent },
      { path: 'members', component: AdminMembersPageComponent },
      { path: 'upgrades', component: AdminUpgradesPageComponent },
      { path: 'branding', component: AdminBrandingPageComponent },
      { path: 'audit-log', component: AdminAuditLogPageComponent },
      { path: 'billing', component: AdminBillingPageComponent },
    ],
  },
];
